
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/categories/coberturas-especiais/[slug]",
      function () {
        return require("private-next-pages/content/categories/coberturas-especiais/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/categories/coberturas-especiais/[slug]"])
      });
    }
  